import React from 'react'
import autoBind from '../utils/autoBind'
import { round } from '../utils/number'
import { toCsString } from '../utils/string'
import * as comp from './computation'
import MainTitle from './MainTitle'
import DNmanual from './DNmanual'
import RoughnessCoef from './RoughnessCoef'
import Slope from './Slope'
import DesignFlow from './DesignFlow'
import Result from './Result'
import PipeFilling from './PipeFilling'
import styles from './s.module.css'

class Dimensioning extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      slope: 10,
      k: 2.5,
      dn: 300,
      id: 300,
      dnIndex: 3,
      Q: 50
    }
    autoBind(['handleDnManualChange', 'handleRoughnessCoefChange', 'handleSlopeInputChange',
       'handleSlopeChange', 'handleQInputChange'], this)
  }

  handleDnManualChange (value) {
    if (value) {
      this.setState({
        id: value,
        dnIndex: Math.min(value / 100, 10)
      })
    }
  }

  handleRoughnessCoefChange (value) {
    this.setState({
      k: value
    })
  }

  handleSlopeInputChange (value) {
    this.setState({
      slope: value
    })
  }

  handleSlopeChange (slope) {
    this.setState({
      slope: slope
    })
  }

  handleQInputChange (value) {
    this.setState({
      Q: value
    })
  }

  render () {
    const { slope, id, dnIndex, k, Q } = this.state
    let velocity, capacity, fill, realFill, realVelocity
    if (slope === 0) {
      velocity = capacity = fill = realFill = realVelocity = 0
    } else {
      velocity = comp.computeVelocity(id, slope, k)
      capacity = comp.computeCapacity(id, velocity)
      fill = Math.round(Q / capacity * 100)
      realFill = fill > 107 ? 1 : comp.fillTable[fill].h
      realVelocity = fill > 107 ? 0 : round(comp.fillTable[fill].v * velocity, 2)
    } 
    return (
      <div className={styles.dimPage}>
        <MainTitle />
        <div className={styles.dimContainer}>
          <div className={styles.dimItemsGroup}>
            <DNmanual value={id} onChange={this.handleDnManualChange} />
            <RoughnessCoef defaultValue={k} onChange={this.handleRoughnessCoefChange} manual />
          </div>
          <div className={styles.dimItemsGroup}>
            <Slope slope={slope} scale={0.175} dnIndex={dnIndex} fill={fill} onInputChange={this.handleSlopeInputChange}
              onGrafChange={this.handleSlopeChange} />
          </div>
          <div className={styles.dimItemsGroup}>
            <Result label='kapacita [l/s]' value={toCsString(capacity, 2)} />
            <Result label='rychlost [m/s]' value={toCsString(velocity, 2)} />
            <DesignFlow label='návrhový průtok [l/s]' value={Q} onChange={this.handleQInputChange} />
            <Result label='skutečná rychlost [m/s]' value={toCsString(realVelocity, 2)} />
          </div>
          <div className={styles.dimItemsGroup}>
            <PipeFilling label='plnění [%]' percent={fill} displayValue={fill} max={1.01} />
            <PipeFilling label='skutečná výška plnění [mm]' percent={Math.round(realFill * 100)}
              displayValue={Math.round(realFill * id)} max={1} />
          </div>
        </div>
        <div className={styles.dimNote}>
          <p className={styles.warningCon}>
            <span className={slope > 35 ? styles.warningOn : styles.warningOff}>
              <strong>Upozornění:</strong> Sklon &gt; 35 ‰. Výpočet nepočítá s provzdušněným proudem.</span>
          </p>
          <p>Teplota vody: 10 °, viskozita: 1,3101 x 10<sup>-6</sup></p>
          <h3>Tipy pro zadávání:</h3>
          <p>Sklon potrubí lze zadat posuvníkem ve schematickém podélném profilu.</p>
          <p className={styles.dimNoteOnlyLarge}>Číselné vstupy je možno upravovat kolečkem myši.</p>
          <p className={styles.diTips}>
            <a href="https://jesyka.cz/">jesyka.cz</a>
          </p>
        </div>
      </div>
    )
  }
}

// Dimensioning.propTypes = {
//   DNs: PropTypes.arrayOf(PropTypes.string),
//   IDs: PropTypes.arrayOf(PropTypes.string),
//   kef: PropTypes.number,
//   manual: PropTypes.bool
// }

export default Dimensioning
